import { ConfirmDialog } from "@/components/common/ConfirmDialog";
import { discardAllDirtyFiles, saveAllDirtyFiles } from "@/lib/save-all";
import {
	settleUnsavedChangesGuard,
	useUnsavedChangesGuardStore,
} from "@/stores/useUnsavedChangesGuardStore";

/** チャットを離れる (切り替え・削除) 前に、未保存のファイルを保存するか捨てるかを選ばせる。 */
export function UnsavedChangesGuardDialog() {
	const open = useUnsavedChangesGuardStore((s) => s.pending !== null);

	return (
		<ConfirmDialog
			open={open}
			title="未保存の変更があります"
			message="このチャットを離れると、開いているファイルのタブは閉じます。未保存の変更を保存しますか?"
			confirmLabel="破棄して続ける"
			alternative={{
				label: "保存して続ける",
				onConfirm: async () => {
					if (!(await saveAllDirtyFiles())) {
						throw new Error(
							"保存できなかったファイルがあります。もう一度試すか、キャンセルしてファイルを確認してください。",
						);
					}
					settleUnsavedChangesGuard(true);
				},
			}}
			onConfirm={async () => {
				discardAllDirtyFiles();
				settleUnsavedChangesGuard(true);
			}}
			onCancel={() => settleUnsavedChangesGuard(false)}
		/>
	);
}
